// Section-header micro icons from Figma (UI Modules, Sidebar/list/header
// 15415-17013): diagonal arrows pointing inward (collapse) / outward (expand).
// Exported verbatim; viewBox crops the export's offset, fill follows text
// color. Shared by the Explorer and PipelineNavBar section headers.
export function CollapseSectionIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="1 1 12 12"
      fill="none"
      role="img"
      aria-label="Collapse section"
    >
      <title>Collapse section</title>
      <path
        d="M11.8523 1.35225C12.0719 1.13258 12.428 1.13258 12.6477 1.35225C12.8673 1.57192 12.8673 1.92799 12.6477 2.14766L9.48287 5.31246H11.125C11.4356 5.31246 11.6875 5.5643 11.6875 5.87496C11.6875 6.18562 11.4356 6.43746 11.125 6.43746H8.12496C7.8143 6.43746 7.56246 6.18562 7.56246 5.87496V2.87496C7.56246 2.5643 7.8143 2.31246 8.12496 2.31246C8.43562 2.31246 8.68746 2.5643 8.68746 2.87496V4.51705L11.8523 1.35225Z"
        fill="currentColor"
      />
      <path
        d="M2.14766 12.6477C1.92799 12.8673 1.57192 12.8673 1.35225 12.6477C1.13258 12.428 1.13258 12.0719 1.35225 11.8523L4.51705 8.68746H2.87496C2.5643 8.68746 2.31246 8.43562 2.31246 8.12496C2.31246 7.8143 2.5643 7.56246 2.87496 7.56246H5.87496C6.02414 7.56246 6.16717 7.62176 6.27266 7.72725C6.37815 7.83274 6.43746 7.97577 6.43746 8.12496V11.125C6.43746 11.4356 6.18562 11.6875 5.87496 11.6875C5.5643 11.6875 5.31246 11.4356 5.31246 11.125V9.48287L2.14766 12.6477Z"
        fill="currentColor"
      />
    </svg>
  );
}

// Boxed-plus "Add" icon from the Bridge_PipelineNavV2 pseudo rows (Figma
// 14397-191575) — the icon lib only has the bare Plus. Exported verbatim at
// 18px, fill follows text color.
export function AddSquareIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      role="img"
      aria-hidden="true"
    >
      <path
        d="M15.75 16.3125V18H2.25V16.3125H15.75ZM16.3125 15.75V2.25C16.3125 1.93934 16.0607 1.6875 15.75 1.6875H2.25C1.93934 1.6875 1.6875 1.93934 1.6875 2.25V15.75C1.6875 16.0607 1.93934 16.3125 2.25 16.3125V18C1.00736 18 0 16.9926 0 15.75V2.25C0 1.00736 1.00736 0 2.25 0H15.75C16.9926 0 18 1.00736 18 2.25V15.75C18 16.9926 16.9926 18 15.75 18V16.3125C16.0607 16.3125 16.3125 16.0607 16.3125 15.75Z"
        fill="currentColor"
      />
      <path
        d="M5.63063 8.15062L12.3806 8.15063C12.8466 8.15063 13.2244 8.52839 13.2244 8.99438C13.2244 9.46037 12.8466 9.83812 12.3806 9.83812H5.63063C5.16463 9.83812 4.78688 9.46037 4.78688 8.99437C4.78688 8.52838 5.16463 8.15062 5.63063 8.15062Z"
        fill="currentColor"
      />
      <path
        d="M8.15625 12.375V5.625C8.15625 5.15901 8.53401 4.78125 9 4.78125C9.46599 4.78125 9.84375 5.15901 9.84375 5.625V12.375C9.84375 12.841 9.46599 13.2188 9 13.2188C8.53401 13.2188 8.15625 12.841 8.15625 12.375Z"
        fill="currentColor"
      />
    </svg>
  );
}

// "Indent" sublevel arrow (↳) — the icon lib has no elbow arrow, so the
// 9.6x12.4 glyph is exported verbatim with the design's top-right inset
// (left 45.31%, top 1.56%): the ink sits in the right half of the box,
// which is what indents it visually while the box itself aligns with
// the standard leading-icon slot. Shared by the SCHEMA sub-section
// header (Figma 14397-191575) and the Tests panel's test rows
// (15013-206515).
export function IndentArrowIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      role="img"
      aria-hidden="true"
    >
      <path
        transform="translate(8.156, 0.281)"
        d="M0 0.84375C0 0.37776 0.37776 0 0.84375 0C1.30974 0 1.6875 0.37776 1.6875 0.84375V7.875H6.68188L5.30969 6.50281C4.98019 6.1733 4.98019 5.6392 5.30969 5.30969C5.6392 4.98019 6.1733 4.98019 6.50281 5.30969L9.31531 8.12219C9.64481 8.4517 9.64481 8.9858 9.31531 9.31531L6.50281 12.1278C6.1733 12.4573 5.6392 12.4573 5.30969 12.1278C4.98019 11.7983 4.98019 11.2642 5.30969 10.9347L6.68188 9.5625H0.84375C0.37776 9.5625 0 9.18474 0 8.71875V0.84375Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ExpandSectionIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="283 14 12 12"
      fill="none"
      role="img"
      aria-label="Expand section"
    >
      <title>Expand section</title>
      <path
        d="M290.523 19.2727C290.303 19.4924 289.947 19.4924 289.727 19.2727C289.508 19.053 289.508 18.697 289.727 18.4773L292.517 15.6875L290.875 15.6875C290.564 15.6875 290.312 15.4357 290.312 15.125C290.312 14.8143 290.564 14.5625 290.875 14.5625L293.875 14.5625C294.024 14.5625 294.167 14.6218 294.273 14.7273C294.378 14.8328 294.438 14.9758 294.438 15.125L294.437 18.125C294.437 18.4357 294.186 18.6875 293.875 18.6875C293.564 18.6875 293.312 18.4357 293.312 18.125L293.312 16.4829L290.523 19.2727Z"
        fill="currentColor"
      />
      <path
        d="M287.477 20.7273C287.697 20.5076 288.053 20.5076 288.273 20.7273C288.492 20.947 288.492 21.303 288.273 21.5227L285.483 24.3125H287.125C287.436 24.3125 287.688 24.5643 287.688 24.875C287.688 25.1857 287.436 25.4375 287.125 25.4375H284.125C283.814 25.4375 283.563 25.1857 283.563 24.875L283.562 21.875C283.562 21.5643 283.814 21.3125 284.125 21.3125C284.436 21.3125 284.688 21.5643 284.688 21.875L284.688 23.5171L287.477 20.7273Z"
        fill="currentColor"
      />
    </svg>
  );
}

// The toolbar's stage-progress step markers (Figma Bridge_Stages,
// 14896-92090), 12px, fill follows the step's text color. "Completed" is
// the Figma export verbatim: a ring with a dot.
export function StageCompletedIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      role="img"
      aria-label="Completed"
    >
      <title>Completed</title>
      <path
        d="M10.875 6C10.875 3.30761 8.69239 1.125 6 1.125C3.30761 1.125 1.125 3.30761 1.125 6C1.125 8.69239 3.30761 10.875 6 10.875V12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12V10.875C8.69239 10.875 10.875 8.69239 10.875 6Z"
        fill="currentColor"
      />
      <path
        d="M7.875 6C7.875 7.03553 7.03553 7.875 6 7.875C4.96447 7.875 4.125 7.03553 4.125 6C4.125 4.96447 4.96447 4.125 6 4.125C7.03553 4.125 7.875 4.96447 7.875 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

// "Not completed" is a dashed ring. Figma holds it as a raster image fill
// (no vector to export), so it is drawn here at the Completed ring's
// metrics: 1.125px stroke, eight dashes, until the icon lib carries it.
export function StageNotCompletedIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      role="img"
      aria-label="Not completed"
    >
      <title>Not completed</title>
      <circle
        cx="6"
        cy="6"
        r="5.4375"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeDasharray="2.4 1.87"
      />
    </svg>
  );
}

// The dashed connector between two steps (Figma Bridge_Stages/arrow,
// 50x14), exported verbatim; fill follows the connector's color.
export function StageArrowIcon() {
  return (
    <svg
      width="50.5"
      height="14"
      viewBox="0 0 50.5 14"
      fill="none"
      role="img"
      aria-hidden="true"
    >
      <path
        d="M50.3536 7.35355C50.5488 7.15829 50.5488 6.84171 50.3536 6.64645L47.1716 3.46447C46.9763 3.2692 46.6597 3.2692 46.4645 3.46447C46.2692 3.65973 46.2692 3.97631 46.4645 4.17157L49.2929 7L46.4645 9.82843C46.2692 10.0237 46.2692 10.3403 46.4645 10.5355C46.6597 10.7308 46.9763 10.7308 47.1716 10.5355L50.3536 7.35355ZM1.5625 7.5H2.0625V6.5H1.5625V7V7.5ZM4.6875 6.5H4.1875V7.5H4.6875V7V6.5ZM7.8125 7.5H8.3125V6.5H7.8125V7V7.5ZM10.9375 6.5H10.4375V7.5H10.9375V7V6.5ZM14.0625 7.5H14.5625V6.5H14.0625V7V7.5ZM17.1875 6.5H16.6875V7.5H17.1875V7V6.5ZM20.3125 7.5H20.8125V6.5H20.3125V7V7.5ZM23.4375 6.5H22.9375V7.5H23.4375V7V6.5ZM26.5625 7.5H27.0625V6.5H26.5625V7V7.5ZM29.6875 6.5H29.1875V7.5H29.6875V7V6.5ZM32.8125 7.5H33.3125V6.5H32.8125V7V7.5ZM35.9375 6.5H35.4375V7.5H35.9375V7V6.5ZM39.0625 7.5H39.5625V6.5H39.0625V7V7.5ZM42.1875 6.5H41.6875V7.5H42.1875V7V6.5ZM45.3125 7.5H45.8125V6.5H45.3125V7V7.5ZM48.4375 6.5H47.9375V7.5H48.4375V7V6.5ZM0 7V7.5H1.5625V7V6.5H0V7ZM4.6875 7V7.5H7.8125V7V6.5H4.6875V7ZM10.9375 7V7.5H14.0625V7V6.5H10.9375V7ZM17.1875 7V7.5H20.3125V7V6.5H17.1875V7ZM23.4375 7V7.5H26.5625V7V6.5H23.4375V7ZM29.6875 7V7.5H32.8125V7V6.5H29.6875V7ZM35.9375 7V7.5H39.0625V7V6.5H35.9375V7ZM42.1875 7V7.5H45.3125V7V6.5H42.1875V7ZM48.4375 7V7.5H50V7V6.5H48.4375V7Z"
        fill="currentColor"
      />
    </svg>
  );
}

// The connector once the steps on both of its ends are completed (Figma
// 14895-206043): the same arrow with a solid shaft, exported verbatim.
export function StageArrowFilledIcon() {
  return (
    <svg
      width="50.5"
      height="14"
      viewBox="0 0 50.5 14"
      fill="none"
      role="img"
      aria-hidden="true"
    >
      <path
        d="M50.3536 7.35355C50.5488 7.15829 50.5488 6.84171 50.3536 6.64645L47.1716 3.46447C46.9763 3.2692 46.6597 3.2692 46.4645 3.46447C46.2692 3.65973 46.2692 3.97631 46.4645 4.17157L49.2929 7L46.4645 9.82843C46.2692 10.0237 46.2692 10.3403 46.4645 10.5355C46.6597 10.7308 46.9763 10.7308 47.1716 10.5355L50.3536 7.35355ZM0 7V7.5H50V7V6.5H0V7Z"
        fill="currentColor"
      />
    </svg>
  );
}
